export default "__VITE_ASSET__BO8zwamV__"